<template>
  <div>
    <!-- User Info: Input Fields -->
    <validation-observer ref="simpleRules">
      <b-form>
        <b-row>
          <!-- Field: firstName -->
          <b-col cols="12" md="4">
            <b-form-group>
              <label>First Name</label>
              <validation-provider
                #default="{ errors }"
                rules="required"
                name="First Name"
              >
                <b-form-input
                  v-model="model.first_name"
                  :state="errors.length > 0 ? false : null"
                  placeholder=""
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <!-- Field: LastName -->
          <b-col cols="12" md="4">
            <b-form-group>
              <label>Last Name</label>
              <validation-provider
                #default="{ errors }"
                name="Last Name"
                rules="required"
              >
                <b-form-input
                  v-model="model.last_name"
                  :state="errors.length > 0 ? false : null"
                  placeholder=""
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <!-- Field: Mail -->
          <b-col cols="12" md="4">
            <b-form-group>
              <label>Email</label>
              <validation-provider
                #default="{ errors }"
                name="Email"
                rules="email"
              >
                <b-form-input
                  v-model="model.mail"
                  :state="errors.length > 0 ? false : null"
                  placeholder=""
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <!-- Field: PhoneNumbre -->
          <b-col cols="12" md="4">
            <b-form-group>
              <label>Phone Numbre</label>
              <validation-provider
                #default="{ errors }"
                name="Phone Number"
                rules="required"
              >
                <b-form-input id="phoneNumbre" v-model="model.phone_number" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <!-- Field: Adress -->
          <b-col cols="12" md="4">
            <b-form-group label="Adress" label-for="nameCountry">
              <b-form-input id="Adress" v-model="model.adress" />
            </b-form-group>
          </b-col>

          <!-- Field: BirthDate -->
          <b-col cols="12" md="4">
            <b-form-group>
              <label>Birth Date</label>
              <validation-provider
                #default="{ errors }"
                name="Birth Date"
                rules=""
              >
                <flat-pickr
                  v
                  class="form-control"
                  v-model="model.birth_date"
                  :state="errors.length > 0 ? false : null"
                  placeholder=""
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <!-- Field: City -->
          <b-col cols="12" md="4">
            <b-form-group label="City" label-for="user-status">
              <validation-provider
                #default="{ errors }"
                name="City"
                rules="required"
              >
                <v-select
                  v-model="model.cityId"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="cityOptions"
                  :reduce="(val) => val.value"
                  :clearable="false"
                  input-id="user-status"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <!-- Field: Status -->
          <b-col cols="12" md="4">
            <b-form-group label="Status" label-for="user-status">
              <v-select
                v-model="model.status"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="statusOptions"
                :reduce="(val) => val.value"
                :clearable="false"
                input-id="user-status"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>

    <!-- Action Buttons -->
    <b-button
      variant="primary"
      class="mb-1 mb-sm-0 mr-0 mr-sm-1"
      :block="$store.getters['app/currentBreakPoint'] === 'xs'"
      @click.prevent="validationForm"
    >
      Create Customer
    </b-button>
    <b-button
      variant="outline-secondary"
      type="reset"
      :block="$store.getters['app/currentBreakPoint'] === 'xs'"
      @click="reset"
    >
      Reset
    </b-button>
  </div>
</template>

<script>
import {
  BButton,
  BMedia,
  BAvatar,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BTable,
  BCard,
  BCardHeader,
  BCardTitle,
  BFormCheckbox,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  required,
  email,
  confirmed,
  url,
  between,
  alpha,
  integer,
  password,
  min,
  digits,
  alphaDash,
  length,
} from "@validations";
import { avatarText } from "@core/utils/filter";
import vSelect from "vue-select";
import router from "@/router";
import store from "@/store";
import { useInputImageRenderer } from "@core/comp-functions/forms/form-utils";
import { ref } from "@vue/composition-api";
import flatPickr from "vue-flatpickr-component";
// Notification
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    BButton,
    BMedia,
    BAvatar,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BTable,
    BCard,
    BCardHeader,
    BCardTitle,
    BFormCheckbox,
    vSelect,
    flatPickr,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    userData: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    validationForm() {
      this.$refs.simpleRules.validate().then((success) => {
        if (success) {
          // eslint-disable-next-line
          this.createCountry();
        }
      });
    },
  },
  setup(props) {
    const toast = useToast();

    const cityOptions = ref([]);

    const statusOptions = [
      { label: "Active", value: true },
      { label: "Inactive", value: false },
    ];

    const model = ref({
      identification_number: "",
      first_name: "",
      last_name: "",
      mail: "",
      phone_numbre: "",
      birth_date: "",
      cityId: "",
      adress: "",
      id_user: 1,
      photo: "photo",
      status: true,
    });
    const userData = ref(null);
    const city = [];
    store
      .dispatch("app-user/fetchHelpers")
      .then((response) => {
        const { cities } = response.data.data;

        cities.map((data, item) => {
          city.push({ label: data.name, value: data.id, id: item });
        });

        cityOptions.value = city;
      })
      .catch((error) => {
        if (error.response.status === 404) {
          userData.value = undefined;
        }
      });

    const createCountry = () => {
      model.value.birth_date.length > 0
        ? model.value.birth_date
        : (model.value.birth_date = new Date());
      store
        .dispatch("app-user/addCountry", { model })
        .then((response) => {
          userData.value = response.data;
          toast({
            component: ToastificationContent,
            props: {
              title: `The customer ${model.value.name} was created correctly`,
              icon: "AlertTriangleIcon",
              variant: "success",
            },
          });
          router.push({ name: "apps-customers-list" });
        })
        .catch((error) => {
          if (error.response.status === 404) {
            userData.value = undefined;
          }
        });
    };

    const reset = () => {
      model.value.identification_number = "";
      model.value.first_name = "";
      model.value.last_name = "";
      model.value.mail = "";
      model.value.phone_numbre = "";
      model.value.birth_date = "";
      model.value.cityId = "";
      model.value.adress = "";
      model.value.id_user = "";
      model.value.photo = "photo";
      model.value.status = true;
    };

    return {
      avatarText,
      statusOptions,
      model,

      createCountry,
      reset,

      alpha,

      cityOptions,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
